import { TEXT_VALIDATION_RULE_TYPES } from "./textValidationRulesTab.vue";
import { VALIDATOR_TYPES } from "Validation/validator";
import { validate as validateCharacterSetRule } from "./characterSetValidator";
import { validate as validatePatternMatchRule } from "./patternMatchValidator";

export const PUNCTUATION_SET = new Set([
    "!",
    "'",
    "#",
    "$",
    "%",
    "&",
    "*",
    "+",
    ",",
    "-",
    ".",
    ";",
    "=",
    "?",
    "@",
    "^",
    "_",
    "~",
    ":"
]);

const UPPERCASE_LETTER_REGEX = /^[\p{Lu}]+$/u;
const LOWERCASE_LETTER_REGEX = /^[\p{Ll}]+$/u;
const NUMERIC_DIGIT_REGEX = /\d/;
const WHITESPACE_REGEX = /\s/;

export function getTextValidationRuleValidatorOptions(ruleType, ruleSchema, errorMessage) {
    let validateMethod;

    switch (ruleType) {
        case TEXT_VALIDATION_RULE_TYPES.CHAR_SET:
            validateMethod = (value) => validateCharacterSetRule(value, ruleSchema);
            break;
        case TEXT_VALIDATION_RULE_TYPES.PATTERN_MATCH:
            validateMethod = (value) => validatePatternMatchRule(value, ruleSchema);
            break;
        default:
            return null;
    }

    return {
        type: VALIDATOR_TYPES.custom,
        validate: validateMethod,
        errorMsg: errorMessage
    };
}

export function isUppercaseLetter(inputChar) {
    return testInputAgainstRegex(UPPERCASE_LETTER_REGEX, inputChar);
}

export function isLowercaseLetter(inputChar) {
    return testInputAgainstRegex(LOWERCASE_LETTER_REGEX, inputChar);
}

export function isLetterAnyCase(inputChar) {
    return isUppercaseLetter(inputChar) || isLowercaseLetter(inputChar);
}

export function isNumericDigit(inputChar) {
    const r = testInputAgainstRegex(NUMERIC_DIGIT_REGEX, inputChar);
    return r;
}

function testInputAgainstRegex(regex, inputChar) {
    return regex.test(inputChar);
}

export function isLetterOrNumericDigit(inputChar) {
    return isLetterAnyCase(inputChar) || isNumericDigit(inputChar);
}

export function isInPunctuationSet(inputChar) {
    return PUNCTUATION_SET.has(inputChar);
}

export function isWhitespace(inputChar) {
    return testInputAgainstRegex(WHITESPACE_REGEX, inputChar);
}
